<template>
  <div class="content">
    <section>
      <h2>
        批量新增临时工
        <a @click="downloadExample">【 下载示例模版 】</a>
      </h2>
      <div class="hint">
        <h3>注意事项</h3>
        <span>1、 必须为.xls或.xlsx结尾的excel；</span>
        <span>2、表格中不得有空行空列，无数据填0；</span>
        <span>3、表格中所有数据均为文本格式；</span>
        <span>4、表格中日期格式以-作为连接符(如2022-02-28)。</span>
      </div>
      <div>
        <label><i>*</i>项目：</label>
        <a-select
          style="width:200px"
          @change="selectRole"
          showSearch
          :filterOption="filterOption"
          v-model="project_id"
          placeholder="请选择应聘项目"
        >
          <a-select-option
            v-for="(item, i) in proList"
            :key="i"
            :value="item.id"
            >{{ item.project_name }}</a-select-option
          >
        </a-select>
      </div>
      <div>
        <label><i>*</i>岗位：</label>
        <a-select
          style="min-width:200px"
          showSearch
          :filterOption="filterOption"
          v-model="role_id"
        >
          <a-select-option
            :value="element.id"
            v-for="(element, k) in roleList"
            :key="k"
            >{{ element.role_name }}</a-select-option
          >
        </a-select>
      </div>
      <div>
        <label><i>*</i>简历渠道：</label>
        <a-radio-group v-model="resume_source_select">
          <a-radio :value="1">
            本人
          </a-radio>
          <a-radio :value="2">
            其他
          </a-radio>
        </a-radio-group>
      </div>
      <div v-show="resume_source_select == 2">
        <label><i>*</i>其他：</label>
        <a-select style="width:200px" v-model="resume_third_part_id">
          <a-select-option
            :value="element.id"
            v-for="(element, i) in channelList"
            :key="i"
          >
            {{ element.name }}
          </a-select-option>
        </a-select>
      </div>
      <div>
        <label><i>*</i>表格：</label>
        <input type="file" @change="excelData" />
      </div>
      <a-button class="submitStyle" type="primary" @click="submitBatchAdd">{{
        upDataHouseText
      }}</a-button>
    </section>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      excel: "",
      upDataHouseText: "提交",
      proList: [],
      project_id: "",
      roleList: [],
      role_id: "",
      channelList: [],
      resume_source_select: "",
      resume_third_part_id: ""
    };
  },
  mounted() {
    this.getPro(); //获取项目
  },
  methods: {
    selectRole(val) {
      this.isShowRole = true;
      this.getRole(val);
      this.getChannelList(val);
    },
    getRole(val) {
      this.roleList = [];
      // this.role_id = "";
      this.isShowRole = false;
      let url =
        this.httpsBasic.url + this.httpsBasic.user + "role/getRoleByProjectId";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          per_page: 10000,
          project_id: val
        })
        .then(res => {
          if (res.data.code == 200) {
            this.roleList = res.data.data;
            this.isShowRole = true;
          } else {
            this.isShowRole = true;
          }
        });
    },
    getPro() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/queryManagerProject";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proList = res.data.data;
          }
        });
    },
    getChannelList(val) {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.finance +
        "Reimbursement/getThirdPartByProjectId";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          project_id: val
        })
        .then(res => {
          if (res.data.code == 200) {
            this.channelList = res.data.data;
            // console.log(this.channelList);
          }
        });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    downloadExample() {
      window.location.href =
        this.httpsBasic.url +
        this.httpsBasic.user +
        "User/batchTempUserTpl?token=" +
        window.localStorage.getItem("xnwfPcToken");
    },
    verify() {
      let fls = true;
      if (this.project_id == "") {
        this.$message.error("请选择项目！");
        fls = false;
        return fls;
      }
      if (this.role_id == "") {
        this.$message.error("请选择岗位!");
        fls = false;
        return fls;
      }
      if (this.resume_source_select == "") {
        this.$message.error("请选择来源!");
        fls = false;
        return fls;
      }
    },
    submitBatchAdd() {
      let _this = this;
      if (this.excel != "") {
        this.$confirm({
          title: "表格一旦上传，临时工账号自动新建?",
          okText: "确认",
          okType: "danger",
          cancelText: "取消",
          onOk() {
            _this.upExcel();
          },
          onCancel() {
            // console.log("Cancel");
          }
        });
      } else {
        this.$message.warning("请选择规定格式的Excel上传！");
      }
    },
    upExcel() {
      this.upDataHouseText = "上传中...";
      let formData = new FormData();
      formData.append("excel", this.excel);
      formData.append("project_id", this.project_id);
      formData.append("role_id", this.role_id);
      formData.append("resume_source_select", this.resume_source_select);
      formData.append("resume_third_part_id", this.resume_third_part_id);
      formData.append("token", window.localStorage.getItem("xnwfPcToken"));
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      let url =
        this.httpsBasic.url + this.httpsBasic.user + "user/batchTempUserUpload";
      axios
        .post(url, formData, config)
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success("上传成功");
            this.project_id = "";
            this.role_id = "";
            this.resume_source_select = "";
            this.resume_third_part_id = "";
            this.excel = "";
            this.$emit("hideInBatchAdd", false);
          } else {
            this.$message.warning(res.data.message);
          }
          this.upDataHouseText = "上传";
        })
        .catch(err => {
          this.$message.error(err);
          this.upDataHouseText = "上传";
        });
    },
    excelData(e) {
      this.excel = e.target.files[0];
    }
  }
};
</script>
<style lang="less" scoped>
.content {
  margin: 30px 5%;
  > section {
    margin-bottom: 80px;
    h2 {
      font-size: 16px;
      line-height: 22px;
      margin-bottom: 10px;
      font-weight: normal;
      a {
        font-size: 12px;
      }
    }
    > div {
      margin: 20px 0;
    }
    .submitStyle {
      margin-left: 60px;
    }
    i {
      font-style: normal;
      display: inline-block;
      color: red;
      margin-right: 4px;
    }
  }
  .hint {
    background: rgba(230, 162, 60, 0.1);
    padding: 10px 20px;
    margin: 10px 30px 20px;
    width: 400px;
    h3 {
      color: #666;
      font-size: 16px;
      font-weight: normal;
    }
    span {
      display: block;
      font-size: 14px;
      line-height: 24px;
      color: #666;
    }
  }
}
</style>
